import React, { ReactNode } from 'react';
// CSSはインポートした順に生成され、後にインポートしたCSSの方が優先されるので、
// まず他のコンポーネントや共通CSSをインポートして、その後でコンポーネントごとのCSSをインストールすること
// つまり、styles.module.cssのインポートはインポート文の複数行のうちの最後に置いておくのが安全
import styles from './styles.module.css';

export type FontTitleProps = {
    className?: string;
    domType?: string;
    children?: ReactNode;
};


const FontTitle : React.FC<FontTitleProps> = ({
    className = '',
    domType = undefined,
    children,
}) => {
    // class属性を設定
    let classString = styles['font-title'];
    if (className) {
        classString = [classString, className].join(' ');
    }

    if (domType === 'span') {
        return (
            <span className={classString} data-testid='span-font-title'>{children}</span>
        )
    } else if(domType === 'p') {
        return (
            <span className={classString} data-testid='p-font-title'>{children}</span>
        )
    } else { // デフォルトはdiv
        return (
            <div className={classString} data-testid='div-font-title'>{children}</div>
        )
    }
};

export default FontTitle;
